//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters, mapState} from 'vuex'

export default {
  name: 'Increase',
  props: ['type'],
  computed: {
    ...mapGetters([
      'vcListNoSettleEnabled'
    ]),
    ...mapState({
      coinListWithPrice: state => state.vc.coinListWithPrice
    }),
    vcListWithType () {
      return this.vcListNoSettleEnabled.filter(item => item.type === this.type)
    },
    coinList () {
      if (!this.coinListWithPrice.length) return []
      return this.vcListWithType.map(settleItem => {
        return this.coinListWithPrice.find(coinWithPriceItem => {
          return settleItem.id === coinWithPriceItem.a
        })
      }).filter(item => !!item).slice(0, 5)
    }
  },
  methods: {
    clickVcItem (currency) {
      this.$store.dispatch('setVcId', currency.a)
        .then(() => {
          this.$router.push('/trade')
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Home/components/Ranking/components/Coins/Coins.vue